<template>
	<ul>
		<li class="content-list" @click="listClick">
			<ProviderExpand :providerwise-patient-count="providerwisePatientCount"
				:total-count="allPatientCount">
					All Patients
			</ProviderExpand>
		</li>

		<li v-for="label in labels" :key="label.id" @click="listClick">
			<router-link :to="'/label/' + label.id">
				{{ label.title }}
				<span>
					{{  count['label:' + label.id] || 0 }}
				</span>
			</router-link>
		</li>
	</ul>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import SidebarList from '.'
import ProviderExpand from './ProviderExpand'
import isEmptyObject from '@/module/util/empty-object'

export default {
	name: 'sidebar-patient-list',
	extends: SidebarList,

	mounted() {
		if (this.getUserType === 'observer') {
			document.querySelectorAll('.content-list a.router-link-active').forEach(element => element.style.backgroundColor = '#1B98CD')
			document.querySelectorAll('.content-list a.router-link-active:not(.active)').forEach(element => element.style.backgroundColor = '#ffffff')
		}
	},

	methods: {
		listClick() {
			if (this.getUserType === 'observer') {
				document.querySelectorAll('.content-list a').forEach(element => element.style.backgroundColor = '#F8F8F8')
				document.querySelectorAll('.content-list a.router-link-active').forEach(element => element.style.backgroundColor = '#1B98CD')
				document.querySelectorAll('.content-list a.router-link-active:not(.active)').forEach(element => element.style.backgroundColor = '#ffffff')
			}
		}
	},

	computed: {
		...mapState('provider', [
            'siteOverview',
			'allPatientCount'
        ]),
		...mapGetters('provider', [
			'getProviderPatientList',
            'getAllProviderPatientList'
		]),
		...mapGetters(['getUserType']),
		providerwisePatientCount() {
			if(!isEmptyObject(this.siteOverview))
				return  Object.entries(this.siteOverview).reduce((acc, overviewPair) => {
					const provider = overviewPair[0]
					const count = overviewPair[1].count
					acc[provider] = count
					return acc
				}, {})
            return this.getProviderPatientList.reduce((acc, providerPatient) => ({...acc, [providerPatient.id] : providerPatient.patient.length}), {})
        },

	},

	components: {
		ProviderExpand
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
